import React, { useState, useEffect } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import './style.scss';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { allocationService, Util } from "../../../services";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { Dialog } from 'primereact/dialog';
import moment from "moment";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import MilestoneUpdateDialog from './updateMilestoneDialoge';
import { selectData } from "../../../services/store/userSlice";
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
// import { IconField } from 'primereact/iconfield';
// import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

export default function ProjectMilestone() {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const projectId = new URLSearchParams(search).get("projectId");
    const [projectTimeline, setProjectTimeline] = useState([]);
    const [showUpdateMilestoneDialog, setShowUpdateMilestoneDialog] = useState(false);
    const [clickedMilestone, setClickedMilestone] = useState([]);
    const [projectPercentage, setProjectPercentage] = useState([]);
    const projectDetailData = useSelector(selectData);

    useEffect(() => {
        // console.log(projectDetailData, "projectDetailData")
        getProjectTimeline(projectId);
        fetchProjectComplationPercentage(projectId);
    }, []);

    const fetchProjectComplationPercentage = (projectId) => {
        allocationService.getProjectComplationPercentage(projectId).then(resp => {
            try {
                if (resp?.data == null) {
                    setProjectPercentage([]);
                } else {
                    setProjectPercentage(resp?.data?.data);
                }
            } catch (error) {
                console.log(error);
            }
        });
    };

    const getProjectTimeline = (projectId) => {
        allocationService.getTimelineByProject(projectId).then(resp => {
            setProjectTimeline(resp.data.data.sort((a, b) => {
                if (a.code < b.code) return -1;
                if (a.code > b.code) return 1;
                return 0;
            }));
        });
    };


    // const percentageBody = (rowData) => {
    //     const sortedMilestone = rowData.projectMilestone.sort((a, b) => b.id - a.id);
    //     return (
    //         <strong>{sortedMilestone[0].percentage}</strong>
    //     )
    // }

    const descriptionBody = (rowData) => {
        // const sortedMilestone = rowData.projectMilestone.sort((a, b) => b.id - a.id);
        return (
            <strong>{rowData.description}</strong>
        )
    }

    const reject = () => {
    };

    const acceptFunc = (rowData) => {
        let params = {
            milestoneId: rowData.id,
            isComplete: true,
        }
        allocationService.completeMilestone(params).then((resp) => {
            toast.info("Milestone updated successfully...");
            getProjectTimeline(projectId);
        }, (error) => {
            toast.error(error.response.data.error);
        }).catch(e => {
            toast.error("Unable to update...");
        });
    };

    const onClickUpdate = (rowData) => {
        confirmDialog({
            message: <p>Do you want to complete this milestone? <br /> Please note once submitted this can't be undone!</p>,
            header: "Milestone Confirmation",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => acceptFunc(rowData),
            reject,
        });
        // setClickedMilestone(rowData);
        // setShowUpdateMilestoneDialog(true);
    }

    const UpdateMilestoneDialog = () => {
        return (<>
            <Dialog visible={showUpdateMilestoneDialog} style={{ width: '40vw' }} onHide={() => setShowUpdateMilestoneDialog(false)}>
                <MilestoneUpdateDialog
                    onClose={(e) => { setShowUpdateMilestoneDialog(false); }}
                    milestoneData={clickedMilestone}
                // projectName={projectDetailData.title}
                // projectId={projectId}
                // onLoad={() => onLoad()}
                // currentUserData={updatedUserData}
                />
                {/* <Fieldset legend="Update Project Completion">
                    <form onSubmit={formik.handleSubmit} className="p-fluid p-grid">
                        <div className="col grid">
                            <div className="col-4 mt-2">
                                <strong style={{ fontSize: '16px', fontWeight: '400' }}>Percentage</strong>
                            </div>
                            <div className="col-3">
                                <InputNumber max={100} value={formik.values.percentage} onChange={formik.handleChange} className='inputPercentage' id="percentage"
                                    name="percentage" />
                            </div>
                            <div className="col-4 ml-12">
                                <Button type="submit" label="Update" />
                            </div>
                        </div>
                    </form>
                </Fieldset> */}
            </Dialog>
        </>)
    }

    const completeMilestoneDate = (rowData) => {
        if (rowData.isComplete === true) {
            return (
                <span>{Util.milestoneUpdatedDate(rowData)}</span>
            )
        } else {
            return (
                <span>N/A</span>
            )
        }
    }

    const startDateBody = (rowData) => {
        return rowData.startDate ? rowData.startDate : 'N/A'
    }

    const completePercentageDate = (rowData) => {
        return (
            <span>{Util.percentageUpdatedDate(rowData)}</span>
        )
    }

    const updateMilestone = (rowData) => {
        if (rowData.isComplete === true) {
            return (
                <Button icon="pi pi-ban" className="p-button-rounded p-button-secondary mr-2" tooltip="Milestone Completed" tooltipOptions={{ position: "top" }} disabled></Button>
            )
        } else {
            return (
                <Button icon="pi pi-check" className="p-button-rounded p-button-secondary mr-2" tooltip="Complete Milestone" tooltipOptions={{ position: "top" }} onClick={() => onClickUpdate(rowData)}></Button>
            )
        }
    }


    const formik = useFormik({
        initialValues: {
            percentage: "",
        },
        validate: (data) => {
            let errors = {};
            if (!data.percentage) {
                errors.percentage = "Percentage is required.";
            }
            if (data.percentage > 100) {
                errors.percentage = "Percentage should be equal or less tham 100.";
            }
            return errors;
        },
        onSubmit: (data) => {
            let params = {
                projectId: projectId,
                date: moment(new Date()).format("YYYY-MM-DD"),
                percentage: data.percentage,
            };
            try {
                allocationService.updateProjectMilestone(params).then(
                    (resp) => {
                        formik.resetForm();
                        fetchProjectComplationPercentage(projectId);
                        toast.info("Percentage updated successfully...");
                    },
                    (resp) => {
                        toast.error(resp.response.data.error);
                    }
                );
            } catch (error) {
                toast.error("Unable to update...");
            }
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const colClass = projectDetailData.projectGroup === 'Milestone' && projectDetailData.projectTypes.code === 'FixedPrice' ? 'col-8' : 'col-12';


    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        code: { value: null, matchMode: FilterMatchMode.EQUALS }
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end mt-2 mb-2">
                <p className='mr-4'>Search By Milestone/Code:</p>  <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
            </div>
        );
    };
    const header = renderHeader();

    return (
        <>
            <div className="col grid">
                {projectDetailData.projectGroup === 'Milestone' && projectDetailData.projectTypes.code === 'FixedPrice' && (
                    <>
                        <div className="col-4 label pl-3">
                            <Fieldset legend="Update Project Completion">
                                <form onSubmit={formik.handleSubmit} className="p-fluid p-grid">
                                    <div className="col grid">
                                        <div className="col-7 mt-1">
                                            <strong style={{ fontSize: '16px', fontWeight: '700' }}>Current Percentage : </strong>
                                        </div>
                                        <div className="col-3 mt-1">
                                            <span className="value bordered" style={{ minWidth: '75px', padding: '5px', background: '#f8f9fa', border: '1px solid #dee2e6', textAlign: 'center', display: 'inline-block', fontWeight: '700' }}>{(projectPercentage[0]?.percentage) ? projectPercentage[0]?.percentage : 0}%</span>
                                        </div>
                                    </div>
                                    <div className="col grid">
                                        <div className="col-6 mt-2">
                                            <strong style={{ fontSize: '16px', fontWeight: '400' }}>Update Percentage</strong>
                                        </div>
                                        <div className="col-3">
                                            <InputText max={100} value={formik.values.percentage} onChange={formik.handleChange} className='inputPercentage' id="percentage" name="percentage" />
                                        </div>

                                        <div className="col-4">
                                            <Button style={{ width: '80px' }} type="submit" label="UPDATE" />
                                        </div>
                                        {getFormErrorMessage('percentage')}
                                    </div>
                                </form>
                            </Fieldset>
                        </div>
                        {/* <div className="col-2"></div> */}
                        <div className="col-8 label pl-3">
                            <Fieldset legend="Update Project History">
                                <DataTable value={projectPercentage}>
                                    <Column field="date" header="Date" body={completePercentageDate} headerStyle={{ width: "30rem" }} />
                                    <Column field="percentage" header="Percentage" headerStyle={{ width: "15rem" }} />\
                                </DataTable>
                            </Fieldset>
                        </div>
                    </>
                )}


                {/* <div className={`${colClass} value bordered`}> */}
                <div className='col-12 value bordered' style={{overflow: "auto"}}>
                    <Fieldset legend="Project Milestone">
                        {/* <DataTable value={projectTimeline}> */}
                        <DataTable value={projectTimeline} paginator rows={10} dataKey="id" filters={filters} filterDisplay="row" globalFilterFields={['title', 'code']} header={header} emptyMessage="No customers found.">
                            <Column field="id" header="ID" headerStyle={{ width: "5rem" }} />
                            <Column field="title" header="Milestone" headerStyle={{ width: "25rem" }} />
                            <Column field="code" header="Code" headerStyle={{ width: "20rem" }} />
                            <Column field="currency" header="Currency" headerStyle={{ width: "15rem" }} />
                            <Column field="startDate" header="Start Date" body={startDateBody} headerStyle={{ width: "15rem" }} />
                            <Column field="value" header="Value" headerStyle={{ width: "15rem" }} />
                            <Column field="endDate" header="Completed On" body={completeMilestoneDate} headerStyle={{ width: "30rem" }} />
                            <Column header="Action" body={updateMilestone} />
                        </DataTable>
                    </Fieldset>
                </div>
                <UpdateMilestoneDialog />
            </div>
        </>
    )
}
